<template>
  <div>
    <div class="flex items-center">
      <div class="p-2 w-16">
        <span>Name</span>
      </div>
      <div class="p-2">
        <input
          class="input"
          v-model="form.display_name"
          @focus="onFocus"
          @blur="onBlur"
          @keyup.enter="submit()"
          ref="inputRef"
        />
      </div>
    </div>
    <p
      class="text-red-500 text-xs ml-16 pl-2 opacity-0"
      :class="[!isValid && displayNameBlurred && 'opacity-100']"
    >
      This field is required and must be 2-64 characters long.
    </p>

    <div class="mt-8">
      <Button
        type="primary"
        :loading="postInProgress"
        :disabled="postInProgress"
        @click="submit()"
      >
        Submit
      </Button>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import useState from 'states/generics/useState'
import TextField from 'components/forms/TextField'
import Button from 'components/common/Button'
import useUpdateDisplayName from './useUpdateDisplayName'
import $store from 'store'

export default {
  components: { Button, TextField },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit, root: { $message, $nextTick } }) {
    const [form, setForm] = useState()

    const resetForm = () => {
      const data = {
        display_name: '',
        ...props.initialData,
      }
      setForm(data)
    }

    resetForm()

    const inputRef = ref(null)

    const focusInput = () => {
      $nextTick(() => {
        inputRef.value.focus()
      })
    }

    onMounted(() => {
      focusInput()
    })

    const { updateProfile, postInProgress } = useUpdateDisplayName()

    const submitted = ref(false)
    const isValid = computed(() => {
      if (form.value.display_name) {
        return form.value.display_name.trim().length >= 2
      }
      return false
    })

    const submit = async () => {
      submitted.value = true
      if (!isValid.value) {
        $message.error('Please fix form first')
        return
      }
      await updateProfile(form.value)
      await $store.dispatch('user/refetchUser')
      $message.success('Update succeeded')
      emit('close')
    }

    const displayNameBlurred = ref(false)
    const onFocus = () => {
      displayNameBlurred.value = false
    }
    const onBlur = () => {
      displayNameBlurred.value = true
    }

    return {
      form,
      inputRef,
      submit,
      postInProgress,
      isValid,
      submitted,
      displayNameBlurred,
      onBlur,
      onFocus,
    }
  },
}
</script>
